import { State } from 'redux/initialState';

export interface AiTrackingExtras {
  surface?: 'embed' | 'agent_page';
  conversationId?: string | null;
  messageId?: string | null;
  [key: string]: unknown;
}

const resolveUserRole = (
  role: State['society']['role'] | undefined
): 'admin' | 'partner' | 'user' => {
  if (role?.isAdmin) return 'admin';
  if (role?.isPartner) return 'partner';
  return 'user';
};

export const buildAiTrackingProps = (
  state: State,
  extras: AiTrackingExtras = {}
): Record<string, unknown> => {
  const { user } = state;
  const society = state.society?.actualSociety;
  const aiPlan = society?.configuration?.aiPlan;
  const role = state.society?.role;

  return {
    userId: user?._id,
    userName: user?.name,
    userEmail: user?.email,
    userRole: resolveUserRole(role),
    societyId: society?._id,
    societyCIF: society?.cif,
    societyName: society?.name,
    aiPlanEnabled: Boolean(aiPlan?.enabled),
    aiPlanSectionLinksEnabled: Boolean(aiPlan?.sectionLinksEnabled),
    aiTier: aiPlan?.tier,
    ...extras,
  };
};
